import { render, staticRenderFns } from "./SalesByClients.vue?vue&type=template&id=4480185a"
import script from "./SalesByClients.vue?vue&type=script&lang=ts"
export * from "./SalesByClients.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports